export default __webpack_public_path__ + "static/media/logo_white.db835d37.png";